import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import AcupunctureCardService from "../services/AcupunctureCardService";
import PatientService from "../services/PatientService";

export default function AcupunctureCardList() {
  const { patientID } = useParams();
  const navigate = useNavigate();
  const [patient, setPatient] = useState(null);
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      PatientService.getPatientById(patientID),
      AcupunctureCardService.getByPatientId(patientID),
    ])
      .then(([patientData, cardsData]) => {
        setPatient(patientData);
        setCards(cardsData);
      })
      .catch((err) => console.error("Greška pri učitavanju kartona:", err))
      .finally(() => setLoading(false));
  }, [patientID]);

  const handleDelete = (cardID) => {
    if (!window.confirm("Da li sigurno želite da obrišete ovaj karton?")) return;
    AcupunctureCardService.delete(cardID).then(() => {
      setCards((prev) => prev.filter((c) => c.cardID !== cardID));
    });
  };

  if (loading) return <div style={{ padding: "30px", textAlign: "center" }}>Učitavanje...</div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>
          Kartoni akupunkture {patient ? `— ${patient.name} ${patient.surname}` : ""}
        </h3>
        <div>
          <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
            ← Nazad
          </button>
          <button
            className="btn btn-warning me-2"
            onClick={() => navigate(`/patients/${patientID}/acupuncture-cards/new`)}
          >
            ➕ Novi karton (izgled kao PDF)
          </button>
          <button
            className="btn btn-outline-warning"
            onClick={() => navigate(`/patients/${patientID}/acupuncture-cards/new-simple`)}
          >
            ➕ Novi karton (jednostavan izgled)
          </button>
        </div>
      </div>

      {cards.length === 0 ? (
        <p className="text-muted">Nema kreiranih kartona za ovog pacijenta.</p>
      ) : (
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>Broj kartona</th>
              <th>Datum pregleda</th>
              <th>Alopatska dijagnoza</th>
              <th>Akcije</th>
            </tr>
          </thead>
          <tbody>
            {cards.map((c) => (
              <tr key={c.cardID}>
                <td>{c.cardID}</td>
                <td>{c.examDate || "/"}</td>
                <td>{c.allopathicDiagnosis || "/"}</td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => navigate(`/acupuncture-cards/${c.cardID}/edit`)}
                  >
                    ✏️ Otvori (PDF izgled)
                  </button>
                  <button
                    className="btn btn-sm btn-outline-secondary me-2"
                    onClick={() => navigate(`/acupuncture-cards/${c.cardID}/edit-simple`)}
                  >
                    ✏️ Otvori (jednostavno)
                  </button>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => handleDelete(c.cardID)}
                  >
                    🗑️ Obriši
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
